module.exports = __webpack_public_path__ + "img/collins-thumb.da3759d1.png";